var mobileBreak = 1000;

$(function() {

    $('#snaff_products.snaff_home_products .product').hover(function() {
        var img_width = $(this).find('.image').width();
        $(this).find('.product_inner .product-options').css('width', img_width);
        $(this).find('.product_inner .product-options').toggle();
    }, function() {
        var img_width = $(this).find('.image').width();
        $(this).find('.product_inner .product-options').css('width', img_width);
        $(this).find('.product_inner .product-options').toggle();
    });
  
  	// halloween button hover
	$("#Hallowee_btn1, #Hallowee_btn2").hover(function(){
        var hoverimg = $(this).data('hover');
        $(this).attr('src', hoverimg);
        }, function(){
        var hoverimg = $(this).data('src');
        $(this).attr('src', hoverimg);
    });

});

// menu scroll effect
$(window).on("resize scroll", function(e) {

    var scroll = $(window).scrollTop();

//     if (scroll >= 110 && $(window).width() > mobileBreak && $('#snaff_home_header').length) {
//         $('#snaff_nav_bar').addClass('snaff_nav_bar_fixed');
//     } else {
//         $('#snaff_nav_bar').removeClass('snaff_nav_bar_fixed');
//     }

//     if ($(window).width() < mobileBreak) {
//         $('#snaff_nav_bar').removeClass('snaff_nav_bar_fixed');
//     }

    // add mobile fixed menu afer scroll
    // if (scroll >= 500 && $(window).width() < mobileBreak){
    // 	$('#snaff_nav_bar').css('position', 'fixed');
    // }else{
    // 	$('#snaff_nav_bar').attr('style', '');
    // }

});

$(window).on("load resize scroll", function(e) {

    var tailTextHeight = $('div#tail_text').height();
    $('#tail_image').css('height', tailTextHeight);

    // resize slider
    var wrapperWidth = $('#snaff_slider').width();
    wrapperWidth -= 70;

    if ($(window).width() > 800) {
        wrapperWidth = wrapperWidth / 3;
    } else if ($(window).width() < 800 && $(window).width() > 500) {
        wrapperWidth = wrapperWidth / 2;
    } else {
        wrapperWidth = wrapperWidth / 1;
    }

    // $('#snaff_slider .product.span3').css('width', wrapperWidth);

    if ($(window).width() >= 1000) {
        $('#snaff_nav_menu_items').attr('style', '');
    }

});

$(function() {

    // update basket amounts 
    $('.snaff_update_quantity .up').click(function(i) {
        var qid = $(this).data('toupdate');
        var currentVal = $('.' + qid).val();
        var newVal = parseInt(currentVal);
        newVal += 1;
        $('.' + qid).val(newVal);
    });

    $('.snaff_update_quantity .down').click(function(i) {
        var qid = $(this).data('toupdate');
        var currentVal = $('.' + qid).val();
        var newVal = parseInt(currentVal);
        newVal -= 1;
        if (newVal <= 1) {
            newVal = 1;
        }
        $('.' + qid).val(newVal);
    });

    // toggle mobile menu
    $('#menu_toggle').click(function() {
        $('#snaff_nav_menu_items').slideToggle();
        $(this).find('i').toggleClass('fa-bars fa-times');
    });

    // toggle mobile menu
    $('.dropdown').click(function() {
        if ($(window).width() < mobileBreak) {
            $(this).find('.dropdown').slideToggle();
        }
    });

    // hide menu on click
    $('.mobile_links_only a').click(function() {
        $('#menu_toggle').click();
    });

    // stock hover effect
    $('li.dropdown').hover(function() {
        if ($(window).width() > mobileBreak) {
            $(this).children('.dropdown').show();
            $(this).children('.dropdown').stop();
            $(this).children('.dropdown').animate({
                opacity: 1.0
            }, 200);
        }
    }, function() {
        if ($(window).width() > mobileBreak) {
            $(this).children('.dropdown').stop();
            $(this).children('.dropdown').animate({
                opacity: 0.0
            }, 400, function() {
                $(this).hide();
            });
        }
    });

});